export default __webpack_public_path__ + "static/media/2.dfb5cfaf.jpeg";